import React from "react";
// import { useNavigate } from "react-router-dom";
import { StoryType } from "../core/lib/types";

function StoryComponent({ id, vendor, media, caption, createdAt, vendorId, viewed }: StoryType) {
    // const navigate = useNavigate()
    //
    // const routeTo = (story: StoryType) => {
    //     //
    //     navigate('/story', { state: {data: story} })
    //   }
    //
    return (
            <div className="">
                <div onClick={e=> media.type === 'video' ? ( (document.getElementById('svid'+id) as HTMLVideoElement)?.played.length ? (document.getElementById('svid'+id) as HTMLVideoElement)?.pause() : (document.getElementById('svid'+id) as HTMLVideoElement)?.play() ) : '' } key={id}>
                        <div className='flex flex-col'>

                            { typeof(media) !== "undefined" && media.type  === 'image' ?
                            <img style={{ objectFit: 'cover'}} className="relative aspect-square h-auto max-w-full rounded-xl" src={media.url+'#t=0.001'} alt=""/>
                            : typeof(media) !== "undefined" && media.type === 'video' ?
                            <video id={'svid'+id} style={{ objectFit: 'cover'}} playsInline={true} loop className="relative aspect-square h-auto max-w-full rounded-xl" >
                                <source src={media.url+'#t=0.001'}></source>
                                </video>
                            : ''
                            }
                            <div className="flex flex-col text-left pt-3 pb-2 pl-2">
                                <p className="text-sm ">{caption}</p>
                            </div>

                        </div> 
                </div> 
            </div>
    )
}

export default StoryComponent